import React from "react";
import styles from "./Tabs.module.scss";
import { Col, Row } from "reactstrap";

const Tabs = ({ tabs, activeTab, setActiveTab, children }) => {
  return (
    <Row className="g-0 d-flex gap-5 row-gap-2 align-items-center justify-content-between border-bottom border-subtle-secondary text-nowrap">
      <Col xl={"auto"} className="d-flex gap-4 overflow-x-auto">
        {tabs.map((tab, index) => (
          <div
            key={index}
            className={`${styles.tab} fw-semibold ${tab === activeTab ? styles["tab-active"] : ""}`}
            onClick={() => setActiveTab(tab)}
          >
            {tab}
          </div>
        ))}
      </Col>

      {children && <Col xl={"auto"}>{children}</Col>}
    </Row>
  );
};

export default Tabs;